import React, { Fragment } from "react";
import HeroImage from "../components/landing/HeroImage";
import Benefits from "../components/landing/Benefits";
import InnovationFirst from "../components/landing/InnovationFirst";
import Offerings from "../components/landing/Offerings";
import Blog from "../components/landing/Blog";
import Testimonials from "../components/landing/Testimonials";
import Clients from "../components/landing/Clients";


const Landing = () => {
  return(
    <Fragment>
      
       <HeroImage />

       <Benefits />

       <InnovationFirst />

       <Offerings />

       <Blog />

       <Testimonials />

       <Clients />



       

    </Fragment>


  );

}
  
  export default Landing;